export default "__VITE_ASSET__DQp69ngw__"